import { render, staticRenderFns } from "./onGetSpanMethod-editor.vue?vue&type=template&id=ad423214&scoped=true&"
import script from "./onGetSpanMethod-editor.vue?vue&type=script&lang=js&"
export * from "./onGetSpanMethod-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad423214",
  null
  
)

export default component.exports